module.exports = __webpack_public_path__ + "media/components/app-store/static/google-play__qr-download-en-742877cb3becd504e2f56c0087cedd42.svg";